import React, { useEffect, useState } from 'react';

const SessionTimeout = ({ onTimeout }) => {
  const [lastActiveTime, setLastActiveTime] = useState(Date.now());
  const sessionTimeout = 30 * 60 * 1000; // 30 minutes

  useEffect(() => {
    const handleActivity = () => {
      setLastActiveTime(Date.now());
    };

    const events = ['mousemove', 'keydown', 'scroll', 'click'];

    events.forEach((event) => window.addEventListener(event, handleActivity));

    const interval = setInterval(() => {
      if (Date.now() - lastActiveTime > sessionTimeout) {
        onTimeout();
      }
    }, 1000);

    return () => {
      events.forEach((event) => window.removeEventListener(event, handleActivity));
      clearInterval(interval);
    };
  }, [lastActiveTime, onTimeout]);

  return null;
};

export default SessionTimeout;
